import { render, staticRenderFns } from "./ElementFilterTabComp.vue?vue&type=template&id=792b04bc&"
import script from "./ElementFilterTabComp.vue?vue&type=script&lang=js&"
export * from "./ElementFilterTabComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports